<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <div>
        <el-button v-if="serverUpdateJobListAutoRefreshStatus == 'refreshing'" loading
          type="primary">正在刷新中...</el-button>
        <el-button v-if="serverUpdateJobListAutoRefreshStatus == 'countingDown'" type="primary"
          icon="el-icon-refresh">{{
            serverUpdateJobListAutoRefreshLeftSeconds
          }}秒后自动刷新...</el-button>
      </div>

      <div style="display: flex; flex-direction: column; margin-left: 10px;">
        <div>
          <span style="font-size: 0.8rem">当前在用的程序版本：{{ currentAppVersion }}</span>
        </div>
        <div>
          <span style="font-size: 0.8rem">当前在用的excels版本：{{ currentGameConfVersion }}</span>
        </div>
      </div>
    </div>

    <el-table :data="serverUpdateJobList" border size="small" style="width: 931px">
      <el-table-column prop="creator" label="操作人" align="center" width="120">
      </el-table-column>
      <el-table-column prop="createdAt" label="开始时间" align="center" width="150">
      </el-table-column>
      <el-table-column prop="finishStatusDesc" label="已结束" align="center" width="100">
      </el-table-column>
      <el-table-column prop="finishedAt" label="结束时间" align="center" width="150">
      </el-table-column>
      <el-table-column prop="progress" label="进度" align="center" width="60">
      </el-table-column>
      <el-table-column prop="artifacts" label="更新包" show-overflow-tooltip align="center" width="250">
        <template slot-scope="scope">
          <div v-for="item in scope.row.artifacts">
            <span v-if="item.type == 'excels'">excels：</span>
            <span v-if="item.type == 'programs'">程序：</span>
            <span>{{ item.artifact }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.isFinished" class="link-button" @click="cancelServerUpdateJob(scope.row)">取消</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      currentAppVersion: "", // 当前在用的程序版本
      currentGameConfVersion: "", // 当前在用的excels版本

      serverUpdateJobList: [], // 服务器更新任务列表

      serverUpdateJobListAutoRefreshTimer: 0, // 服务器更新任务列表的自动刷新定时器的id
      serverUpdateJobListAutoRefreshStatus: "", // 服务器更新任务列表的自动刷新状态
      serverUpdateJobListAutoRefreshNextAt: 0, // 服务器更新任务列表的下一次自动刷新是什么时候
      serverUpdateJobListAutoRefreshIntervalSeconds: 3, // 服务器更新任务列表的自动刷新间隔时长
      serverUpdateJobListAutoRefreshLeftSeconds: 0, // 距离服务器更新任务列表的下一次自动刷新还剩几秒
    }
  },

  created() {
    // 启动定时器
    this.serverUpdateJobListAutoRefreshTimer = setInterval(this.serverUpdateJobListAutoRefresher, 10);

    // 刷新一次服务器更新任务列表
    this.startAutoQueryServerUpdateJobs();
  },

  beforeDestroy() {
    // 销毁定时器
    clearInterval(this.serverUpdateJobListAutoRefreshTimer);
  },

  methods: {
    /**
     * 定时任务
     */
    serverUpdateJobListAutoRefresher() {
      this.serverUpdateJobListAutoRefreshLeftSeconds = Math.ceil((this.serverUpdateJobListAutoRefreshNextAt - Date.now()) / 1000);
      if (this.serverUpdateJobListAutoRefreshLeftSeconds < 0) {
        this.serverUpdateJobListAutoRefreshLeftSeconds = 0;
      }

      if (this.serverUpdateJobListAutoRefreshLeftSeconds == 0 &&
        this.serverUpdateJobListAutoRefreshStatus == "countingDown") {
        // 刷新一次服务器更新任务列表
        this.startAutoQueryServerUpdateJobs();
      }
    },

    async startAutoQueryServerUpdateJobs() {
      this.serverUpdateJobListAutoRefreshStatus = "refreshing";

      try {
        await this.queryServerUpdateJobs();
      } catch (e) {

      }

      this.serverUpdateJobListAutoRefreshStatus = "countingDown";
      this.serverUpdateJobListAutoRefreshNextAt = Date.now() + (1000 * this.serverUpdateJobListAutoRefreshIntervalSeconds);
    },

    async queryServerUpdateJobs() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageServerUpdateJobs`,
          {
            action: "query",
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      this.serverUpdateJobList = [];

      let respJobs = resData.data.query.jobs;
      let jobList = []
      for (let job of respJobs) {
        let finishStatusDesc = "";
        {
          if (job.isFinished) {
            if (job.isCanceled) {
              finishStatusDesc = "是（取消）";
            } else {
              finishStatusDesc = "是";
            }
          } else {
            finishStatusDesc = "否"
          }
        }

        let finishedAt = "";
        {
          if (job.finishedAt != "0") {
            finishedAt = util.ms2datetime(job.finishedAt);
          }
        }

        let progress = "0%";
        {
          let finishedSteps = 0;

          for (let step of job.steps) {
            if (step.isFinished) {
              finishedSteps++;
            }
          }

          progress = `${Math.floor(100 * (finishedSteps / job.steps.length))}%`;
        }

        let artifacts = [];
        {
          for (let a of job.artifacts) {
            let artifactTag = "";
            let colonPos = a.artifact.lastIndexOf(":");
            if (colonPos >= 0) {
              artifactTag = a.artifact.substr(1 + colonPos);
            }

            artifacts.push({
              type: a.type,
              artifact: artifactTag,
            })
          }

          // 排个序
          artifacts.sort((x, y) => x.type.localeCompare(y.type));
        }

        jobList.push({
          id: job.id,
          createdAt: util.ms2datetime(job.createdAt),
          creator: job.creator,
          isFinished: job.isFinished,
          finishStatusDesc: finishStatusDesc,
          finishedAt: finishedAt,
          progress: progress,
          artifacts: artifacts,
        });
      }

      this.serverUpdateJobList = jobList;

      this.currentAppVersion = resData.data.query.currentAppVersion;
      this.currentGameConfVersion = resData.data.query.currentGameConfVersion;
    },

    async cancelServerUpdateJob(job) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageServerUpdateJobs`,
          {
            action: "cancel",
            cancel: {
              jobId: job.id,
            }
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      this.$alert("已取消", "提示", {
        center: true,
        type: "success",
        callback: (action) => { },
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}

.link-button {
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>